import React from 'react';
import { noop } from 'Utils';
import { Text, View } from 'react-native';
import { Hr, Icon, sectionListStyles } from 'LocalGluons';

import { CachedImage } from 'LocalGluons/components/CachedImage';
import baseStyles from './ChannelFavoriteListItem.jss';

const MIN_IMAGE_SIZE = 20;

interface ChannelFavoriteListItemProps {
    name: string;
    favorite?: boolean;
    onPress?: () => void;
    logoUrl?: string;
    testID?: string;
}

const ChannelFavoriteListItem = ({
    name,
    logoUrl = '',
    onPress = noop,
    favorite = false,
    testID = ''
}: ChannelFavoriteListItemProps): React.ReactElement => (
    <View testID={testID}>
        <View style={baseStyles.innerItemContainer}>
            <View style={baseStyles.logoNameContainer}>
                <CachedImage
                    style={{
                        minWidth: MIN_IMAGE_SIZE * 2,
                        minHeight: MIN_IMAGE_SIZE
                    }}
                    resizeMode="contain"
                    source={{ uri: logoUrl }}
                />
                <Text style={[sectionListStyles.itemName, baseStyles.itemName]} numberOfLines={1}>
                    {name}
                </Text>
            </View>
            <View style={baseStyles.favoriteIcon}>
                <Icon
                    name={favorite ? 'favorite_on' : 'favorite_off'}
                    onPress={onPress}
                    style={{
                        height: 30,
                        width: 30
                    }}
                />
            </View>
        </View>
        <Hr style={baseStyles.itemDivider} />
    </View>
);

export default ChannelFavoriteListItem;
